"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var data_structures_1 = require("@tableau/data-structures");
var vizportal_webclient_api_1 = require("@tableau/vizportal-webclient-api");
var GetSessionInfoMethod_1 = require("@tableau/vizportal-webclient-api/lib/api/methods/GetSessionInfoMethod");
var Localize_1 = require("../../gen-src/Localize");
// TODO connectto handle obfuscated edge case(s)
// connectionType, databaseName, hostName, provider, filePath, connectionUrl, tableName are all nullable now
// what needs to be done with this method in regards to obfuscation?
function getConnectionParamsForDatabase(dataType, database) {
    var typeName = database.__typename;
    var connectionParams = {
        dataType: dataType,
        connectionType: database.connectionType,
        databaseName: database.name,
    };
    switch (typeName) {
        case 'DatabaseServer':
            var databaseServerDatabase = database;
            connectionParams.databaseName = databaseServerDatabase.connectionType !== null &&
                connectionParams.databaseName !== null ?
                cannonicalizeDatabaseName(databaseServerDatabase.connectionType, connectionParams.databaseName)
                : Localize_1.Messages.PermissionsRequired(); // TODO connectto handle obfuscated edge case
            var databaseServerConnectionParams = __assign(__assign({}, connectionParams), { extendedConnectionType: databaseServerDatabase.extendedConnectionType, hostName: databaseServerDatabase.hostName, port: databaseServerDatabase.port, service: databaseServerDatabase.service });
            return databaseServerConnectionParams;
        case 'CloudFile':
            var cloudFileDatabase = database;
            var cloudFileConnectionParams = __assign(__assign({}, connectionParams), { 
                // TODO (TFS-1026213): Clean up the dsClass, connectionType, and provider confusion
                // Given connectionType being the short version string for cloud files,
                // parse a new param "dsClass" for the long connectionType string, e.g. cloudfile:box-excel-direct
                dsClass: cloudFileDatabase.connectionType, 
                // Cloud files require connectionType to be of the short version, e.g. box
                // Except for Google sheets, which requires it to be 'google-sheets' (connectionType),
                // instead of 'google sheets' (provider)
                connectionType: cloudFileDatabase.connectionType === 'google-sheets'
                    ? cloudFileDatabase.connectionType : cloudFileDatabase.provider, fileExtension: getFileExtension(cloudFileDatabase.name), fileId: cloudFileDatabase.fileId, fileName: cloudFileDatabase.name, provider: cloudFileDatabase.provider, requestUrl: cloudFileDatabase.requestUrl, 
                // Google Sheets
                mimeType: cloudFileDatabase.mimeType });
            return cloudFileConnectionParams;
        case 'File':
            var fileDatabase = database;
            var fileConnectorConnectionParams = __assign(__assign({}, connectionParams), { filePath: fileDatabase.filePath });
            return fileConnectorConnectionParams;
        case 'WebDataConnector':
            var webDataConnectorDatabase = database;
            var webDataConnectorConnectionParams = __assign(__assign({}, connectionParams), { connectionUrl: webDataConnectorDatabase.connectorUrl });
            return webDataConnectorConnectionParams;
        default:
            data_structures_1.assertNever(typeName);
            return null;
    }
}
exports.getConnectionParamsForDatabase = getConnectionParamsForDatabase;
function getFileExtension(fileName) {
    return fileName ? fileName.split('.').pop() : null;
}
function cannonicalizeDatabaseName(connectionType, databaseName) {
    // TFS 928003 - Some connection types have no database attribute (HasDatabase is false)
    // but DataCatalog backend overrides this to <hostname:port>
    // We need to override this to undefined for connection commands to succeed
    // This is a temporary fix for V1 and we need to decide on a cleaner solution
    if (connectionType === 'awshadoophive' ||
        connectionType === 'drill' ||
        connectionType === 'exasolution' ||
        connectionType === 'hadoophive' ||
        connectionType === 'hortonworkshadoophive' ||
        connectionType === 'kognitio' ||
        connectionType === 'maprhadoophive' ||
        connectionType === 'oracle' ||
        connectionType === 'saphana' ||
        connectionType === 'spark' ||
        connectionType === 'sybaseiq' ||
        connectionType === 'teradata') {
        return undefined;
    }
    return databaseName;
}
function doesDatasourceHaveDownloadPermission(datasource) {
    return datasource.connectabilityDetails != null
        && !!datasource.connectabilityDetails.hasDownloadPermission;
}
function isIGetDatasourcesResult(result) {
    return result.errors == null;
}
exports.isIGetDatasourcesResult = isIGetDatasourcesResult;
function isIGetFieldValuesResult(result) {
    return result.errors == null;
}
exports.isIGetFieldValuesResult = isIGetFieldValuesResult;
function getConnectionParamsForTable(dataType, table) {
    var tableConnectionParams;
    // MVP we only handle the case for ConnectToTablesConnectionParamsQuery_tables_DatabaseTable
    // For ConnectToTablesConnectionParamsQuery_tables_CustomSQLTable we keep the connectionType as empty string
    if (table.database) {
        var database = table.database;
        var typeName = database.__typename;
        var connectionParams = getConnectionParamsForDatabase(dataType, database);
        // TODO (TFS-1026213): Clean up the dsClass, connectionType, and provider confusion
        // Cloud files require connectionType to be of the short version, e.g. box
        // Except for Google sheets, which requires it to be 'google-sheets' (connectionType),
        // instead of 'google sheets' (provider)
        var tableConnectionType = void 0;
        if (typeName === 'CloudFile' && database.connectionType !== 'google-sheets') {
            var cloudFileDatabase = database;
            tableConnectionType = cloudFileDatabase.provider;
        }
        else {
            tableConnectionType = database.connectionType;
        }
        tableConnectionParams = __assign(__assign({}, connectionParams), { dataType: dataType, connectionType: tableConnectionType, fullTableName: table.fullName || table.name, schema: table.schema });
    }
    else {
        tableConnectionParams = {
            dataType: dataType,
            connectionType: '',
            fullTableName: table.fullName || table.name,
        };
    }
    return tableConnectionParams;
}
exports.getConnectionParamsForTable = getConnectionParamsForTable;
function getConnectionParamsForDatasource(result) {
    if (result.datasources == null || result.datasources.length !== 1) {
        return null;
    }
    var datasource = result.datasources[0];
    var owner = result.users == null
        ? null
        : result.users.find(function (u) { return u.id === datasource.ownerId; });
    var project = result.projects == null
        ? null
        : result.projects.find(function (p) { return p.id === datasource.projectId; });
    return {
        dataType: 'Datasources',
        connectionType: datasource.connectionType,
        datasourceName: datasource.name,
        repositoryUrl: datasource.repositoryUrl,
        isCertified: datasource.certificationDetails.isCertified,
        projectId: datasource.projectId,
        projectName: project != null ? project.name : undefined,
        ownerDisplayName: owner != null ? owner.displayName : undefined,
        hasDownloadPermission: doesDatasourceHaveDownloadPermission(datasource),
    };
}
exports.getConnectionParamsForDatasource = getConnectionParamsForDatasource;
function getSessionInfo(vizPortalWebClientRequester) {
    return __awaiter(this, void 0, void 0, function () {
        var get, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    get = vizPortalWebClientRequester.createSender(GetSessionInfoMethod_1.GetSessionInfoMethod);
                    return [4 /*yield*/, get()];
                case 1:
                    resp = _a.sent();
                    if (isSessionTimeOut(resp)) {
                        return [2 /*return*/, { sessionInfo: null, fetchResponse: resp }];
                    }
                    if (!vizportal_webclient_api_1.WebClientResponseHelper.isErrorResponse(resp)) {
                        return [2 /*return*/, { sessionInfo: resp.response.result, fetchResponse: null }];
                    }
                    return [2 /*return*/, null];
            }
        });
    });
}
exports.getSessionInfo = getSessionInfo;
// tslint:disable-next-line:no-any
function isSessionTimeOut(response) {
    // tslint:disable-next-line:no-any
    var fetchResponse = response.fetchResponse;
    return (fetchResponse && fetchResponse.status === 401);
}
exports.isSessionTimeOut = isSessionTimeOut;
function isRowEnabledForDatasource(datasource) {
    return datasource.connectabilityDetails != null
        && !!datasource.connectabilityDetails.hasConnectPermission
        && !!datasource.connectabilityDetails.isConnectableDBClass
        && !datasource.isHierarchical;
}
exports.isRowEnabledForDatasource = isRowEnabledForDatasource;
function isRowEnabledForTableOrDatabase(connectionType, allowedClasses) {
    return connectionType ? allowedClasses.indexOf(connectionType) > -1 : false;
}
exports.isRowEnabledForTableOrDatabase = isRowEnabledForTableOrDatabase;
//# sourceMappingURL=ConnectToDialogFunctions.js.map